import { LogService } from '@mirage-projects/cw-commons';
import { LogLevel } from '@mirage-projects/cw-models';

const configEnvironment: any = { logLevel: LogLevel.Debug };

export const logService = new LogService(configEnvironment);
